<div class="mt-[0.5rem] flex w-full max-w-[120rem] flex-col lg:px-[1.4rem]">
  <div class="main__live-drop-block">
    <div class="main-block">
      <div class="mb-[1.5rem] ml-[2.5rem] flex items-center space-x-[1rem] sm:hidden">
        <i class="icon icon_three-lines text-[2.8rem] !text-light-300"></i>
        <span class="text-[1.4rem] font-400 uppercase leading-[27px] text-light-300" i18n="@@main.live-drop.title"
          >Live drop</span
        >
      </div>
      @if (mainState.liveDrops().length > 0) {
        <div class="main__live-drops">
          @for (liveDrop of mainState.liveDrops(); track liveDrop.id) {
            <main-live-drop [liveDrop]="liveDrop" [routerLink]="['/profile', liveDrop.user.id]" />
          }
        </div>
      } @else {
        <div class="main__live-drops">
          @for (item of preloadLiveDrops; track $index) {
            <preload-rect className="main__live-drop preload" />
          }
        </div>
      }
    </div>
  </div>
  <div class="flex flex-col space-y-[1.5rem]">
    <div class="ml-[2.5rem] flex items-center space-x-[1rem] sm:hidden">
      <i class="icon_new icon_gamepad icon-translate text-[2.8rem] !text-light-300"></i>
      <span i18n="@@games.minigames" class="text-[1.4rem] font-400 uppercase leading-[27px] text-light-300"
        >Мини игры</span
      >
    </div>
    <div class="main__modes modes-cards">
      @for (gameCard of GAME_CARDS; track gameCard.mode) {
        @if (!gameCard.hideInMain) {
          <main-mode-card
            [cardTitle]="gameCard.title"
            [gameMode]="gameCard.mode"
            [badge]="gameCard.badge"
            [isSoon]="!!gameCard.isSoon"
            [isNew]="!!gameCard.isNew"
            [isHot]="!!gameCard.isHot"
            [disableAnimation]="!!gameCard.disableAnimation"
            [routerLink]="gameCard.routerLink"
            [counter]="authState.counters()[gameCard.mode]"
          />
        }
      }
      <button type="button" class="support_button intercomTrigger">
        <div class="support_button-title">
          <span i18n="@@header.support">Поддержка</span>
          <i class="icon icon_new icon_arrowRight"></i>
        </div>
        <img
          loading="lazy"
          fetchpriority="low"
          class="support_button-mainImg z-[1] mt-[0.8rem]"
          src="assets/images/main/supportIcon.webp"
          alt=""
        />
        <img
          loading="lazy"
          fetchpriority="low"
          class="absolute bottom-0 h-full w-full z-[0]"
          src="assets/images/main/supportLight.webp"
          alt=""
        />
        <div class="support_button-circle"></div>
      </button>
    </div>
  </div>
</div>
